import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { publicRoutes, privateRoutes } from "./router.link";
import AuthGuard from "./AuthGuard";
import HeaderLayouts from "./headerLayout";
import PublicRoute from "./PublicRoute";
import Customerinvoice from "../feature-module/sales/customerinvoice";

const AllRoutes = () => {
  return (
    <Routes>
      {/* Public Routes - No Header */}
      <Route path="/customer-invoice/:id" element={<Customerinvoice />} />
      {publicRoutes.map((route) => (
        <Route
          key={`public-${route.path}-${route.id}`}
          path={route.path}
          element={<PublicRoute>{route.element}</PublicRoute>}
        />
      ))}

      {/* Protected Routes with Header */}
      <Route element={<AuthGuard />}>
        <Route element={<HeaderLayouts />}>
          {privateRoutes.map((route) => (
            <Route
              key={`private-${route.path}-${route.id}`}
              path={route.path}
              element={route.element}
            />
          ))}
        </Route>
      </Route>

      {/* Redirect unmatched routes to signin */}
      <Route path="*" element={<Navigate to="/signin" replace />} />
    </Routes>
  );
};

export default AllRoutes;
